module.exports = "h2, h3 {\n  padding-top: 20px; }\n"